/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Link, InputLabel, TextField, Box, MenuItem, Typography, Button } from "@mui/material"
import { selectBaseStyles, viewTypographyStyles } from "../styles"

export const StyledBreadCrumbContainer = styled('div')({
  height: '20px',
  width: '100%',
  backgroundColor: '#f5f5f8',
  padding: '10px 0px 10px 20px',
  borderColor: '#e0e0e0',
  borderWidth: '0px 0px 1px 0px',
  borderStyle: 'solid',
})

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: 'none',
  color: color,
  fontSize: '13px',
  fontWeight: '400',
}))

export const StyledInputLabel = styled(InputLabel)({
    fontSize: '14px',
})

export const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '8px'
  },
})

export const StyledDiv = styled('div')({
  padding: '0px 15px'
})

export const StyledFormField = styled('div')({
  marginTop: '3%'
})

export const StyledEmployeeDetails = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  p: 1,
  borderBottom: '1px solid #eee',
  '&:hover': { backgroundColor: '#f5f5f5' }
})

export const StyledInput = styled('input')({
  marginRight: '12px',
  cursor: 'pointer',
  width: '16px',
  height: '16px',
  accentColor: '#1976d2'
})

export const filterContainerStyles = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", md: "center" },
  gap: { xs: 2, md: 0 }
}

export const filterGroupStyles = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: { xs: 2, sm: "18px" },
  flexWrap: "wrap",
  width: { xs: "100%", md: "auto" },
  flex: 1
}

export const actionGroupStyles = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  alignSelf: { xs: "flex-start", md: "center" },
  mt: { xs: 1, md: 0 },
  width: { xs: "100%", md: "auto" },
  justifyContent: { xs: "flex-start", md: "flex-end" }
}

export const typographyStyles = {
  ...viewTypographyStyles,
  alignSelf: { xs: "flex-start", sm: "center" },
  whiteSpace: "nowrap"
}

export const formControlStyles = {
  width: { xs: "100%", sm: "auto" },
  minWidth: { xs: "100%", sm: "160px" }
}

export const menuPropStyles = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  style: {
    maxHeight: 400,
  },
  autoFocus: false,
  MenuListProps: { sx: { pt: 0 } },
}

export const selectFieldStyles = {
  ...selectBaseStyles,
  minWidth: { xs: "100%", sm: "160px" },
  borderColor: "#2b4fb9",
}

export const StyledMenuItem = styled(MenuItem)({
  fontSize: "14px",
})

export const StyledTypography = styled(Typography)({

})

export const StyledIgnoreButton = styled(Button)({
  '&:hover': {
    backgroundColor: 'white !important',
    boxShadow: 'none !important',
    color: '#2b4fb9 !important',
  },
  '&.Mui-disabled': {
    backgroundColor: '#ebebeb',
  },
  fontSize: '0.875rem',
  textTransform: 'none',
  fontWeight: 600,
  border: '1px solid rgba(0,0,0,.12)',
  borderRadius: '8px',
  padding: '6px 16px',
  backgroundColor: 'white',
  boxShadow: 'none',
  color: '#2b4fb9',
})
